import React from 'react';
import styled from 'astroturf/react';
import { NewsPreview } from 'js/social/shared/types';
import { CollapsedActivityPreview } from 'js/social/CollapsedActivityPreview';
import _PreviewContainer from "CollapsedActivity-PreviewContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CollapsedActivity.tsx?styleId=PreviewContainer";


const PreviewContainer = /*#__PURE__*/styled("div", null, {
  displayName: "PreviewContainer",
  styles: _PreviewContainer
});

interface Props {
  displayName: string;
  isOwner: boolean;
  preview?: NewsPreview;
  onsitePodcastPromotion?: boolean;
}

const CollapsedActivity: React.FC<React.PropsWithChildren<Props>> = ({
  displayName,
  isOwner,
  preview,
  children,
  onsitePodcastPromotion = false,
}) => {
  return (
    <PreviewContainer>
      {children}

      {!preview ? (
        !isOwner && `${displayName} hasn't posted recently`
      ) : (
        <CollapsedActivityPreview
          displayName={displayName}
          preview={preview}
          onsitePodcastPromotion={onsitePodcastPromotion}
        />
      )}
    </PreviewContainer>
  );
};

export default CollapsedActivity;
